import { useContext, useEffect, useMemo, useState } from "react"
import './index.scss'
import { FilterContext } from "@/App"
import { RESOURCE_MANAGER } from "@/config"
import { Col, Row } from "antd"
import { IAnimation } from "@/packages/sdk/fu_resource_manager"
import CloudBundle from './components/CloudBundle'
import { RendererContext } from "@/components/FURenderkit"
import { AvatarContext } from "@/components/RenderComp/Avatar"

const CloudAnimation = () => {
    const { renderer } = useContext(RendererContext) as FilterContext<typeof RendererContext>
    const { avatarConfig, avatar } = useContext(AvatarContext)
    const [selectedAnimationPath, setSelectedAnimationPath] = useState('')
    const [animationList, setAnimationList] = useState<IAnimation[]>([])
    const [loadedBundle, setLoadedBundle] = useState<any[]>([])
    const gender = useMemo(() => {
        return avatarConfig?.data.gender as string || 'female'
    }, [avatarConfig])

    const flushIndexedDB = () => {
        const map = RESOURCE_MANAGER._fileInfo as Map<string, any>
        setLoadedBundle(Array.from(map.keys()))
    }

    useEffect(() => {
        (async () => {
            if (renderer) {
                flushIndexedDB()
                setAnimationList(RESOURCE_MANAGER.animationList as IAnimation[])
            }
        })()
    }, [renderer])
    useEffect(() => {
        // RESOURCE_MANAGER.getAnimationList()
        return () => {
            const caseGender = gender.slice(0, 1).toUpperCase() + gender.slice(1).toLowerCase()
            if (avatar) {
                avatar.setAnimation(
                    `GAssets/animation/Asia${caseGender}/common/ani_ptag_a${gender}_huxi.bundle`,
                    'DefaultAnimNode',
                    true
                )
            }
        }
    }, [])
    return (
        <div className="animation-content">
            <p className="title">动作资源</p>
            <Row
                className="animation-list better-scroll"
                style={{ minHeight: '300px' }}
            >
                {
                    animationList.map(animation => (
                        animation.filter.gender === gender && <Col
                            span={
                                document.documentElement.clientWidth > 640 ? 8 : 6
                            }
                            key={animation.path}
                        >
                            <CloudBundle
                                gender={gender}
                                item={animation}
                                selectedAnimationPath={selectedAnimationPath}
                                setSelectedAnimationPath={setSelectedAnimationPath}
                                loadedBundle={loadedBundle}
                                flushIndexedDB={flushIndexedDB}
                            />
                        </Col>
                    ))
                }
            </Row>
        </div>
    )
}

export default CloudAnimation
